import { Injectable } from '@angular/core';
import { toLower } from 'lodash';
import * as moment from 'moment-timezone';
import { GeneralService } from './general.service';
import { UsersService } from './users.service';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(private userService: UsersService, private generalService: GeneralService) { } //, private currentUserService: CurrentUserService,) { }

    async trackDownloadAnalyticsInfo(url: string, ResourceType: string): Promise<void> {
        try {
            //Channel Name
            const channelnameCollection = document.getElementsByClassName("channel-name");
            let channelTitle = channelnameCollection != undefined && channelnameCollection != null && channelnameCollection.length > 0 ? channelnameCollection[0].innerHTML.trim() : "";
            channelTitle = decodeURIComponent(channelTitle);
            channelTitle = channelTitle.replace("&amp;", "&");

            //item TA_Asset_Indication 
            const taassetindicationCollection = document.getElementsByClassName("item-ta-asset-indication");
            const taassetindication = taassetindicationCollection != undefined && taassetindicationCollection != null && taassetindicationCollection.length > 0 ? taassetindicationCollection[0].innerHTML.trim() : "";
//  resource-type
const resourceType = ResourceType ? ResourceType : '';
            if(resourceType){
                this.trackAnalytics({
                    'channel': channelTitle,
                    'ta_asset_indi': taassetindication+'#'+resourceType,
                    'fileurl': url,
                    'aheventtype': 'downloadfiles'
                });
            } else {
                this.trackAnalytics({
                    'channel': channelTitle,
                    'ta_asset_indi': taassetindication,
                    'fileurl': url,
                    'aheventtype': 'downloadfiles'
                });
            }
           
        }
        catch (ex) {
            console.log("Error: GA logging failed.")
        }
    }
    trackUploadAnalyticsInfo(url: string, ResourceType:string): void {
        try {
            //Channel Name
            const channelnameCollection = document.getElementsByClassName("channel-name");
            let channelTitle = channelnameCollection != undefined && channelnameCollection != null && channelnameCollection.length > 0 ? channelnameCollection[0].innerHTML.trim() : "";
            channelTitle = decodeURIComponent(channelTitle);
            channelTitle = channelTitle.replace("&amp;", "&");

            //item TA_Asset_Indication 
            const taassetindicationCollection = document.getElementsByClassName("item-ta-asset-indication");
            const taassetindication = taassetindicationCollection != undefined && taassetindicationCollection != null && taassetindicationCollection.length > 0 ? taassetindicationCollection[0].innerHTML.trim() : "";
            const resourceType = ResourceType ? ResourceType : '';
            if(resourceType && resourceType.length > 0){
                this.trackAnalytics({
                    'channel': channelTitle,
                    'ta_asset_indi': taassetindication+'#'+resourceType,
                    'fileurl': url,
                    'aheventtype': 'uploadfiles'
                });
            } else{
                this.trackAnalytics({
                    'channel': channelTitle,
                    'ta_asset_indi': taassetindication,
                    'fileurl': url,
                    'aheventtype': 'uploadfiles'
                });
            }
           
        }
        catch (ex) {
            console.log("Error: GA logging failed.")
        }
    }
    trackChannelsAnalyticsInfo(channelTitle: string): void {
        try {
            //Channel Name
            const d = sessionStorage.getItem('timeout_session');
            // const diff =  this.calculateDiff(d);
            // console.log('thime Diff',diff);
            if (!this.isToday(d)) {
                sessionStorage.removeItem('analytics_general');
                sessionStorage.removeItem('visited_channels');
            }

            if (!channelTitle || channelTitle.length <= 0) {
                const channelnameCollection = document.getElementsByClassName("channel-name");
                channelTitle = channelnameCollection != undefined && channelnameCollection != null && channelnameCollection.length > 0 ? channelnameCollection[0].innerHTML.trim() : "Nil";
            }
            
            channelTitle = decodeURIComponent(channelTitle);
            channelTitle = channelTitle.replace("&amp;", "&");
            let channels = this.generalService.getDataFromSession('visited_channels');
            if (channelTitle && channelTitle.length > 0) {
                if (channels) {
                    channels.push(channelTitle);
                } else {
                    channels = [channelTitle];
                }
                const uniqueChannels = channels ? [...new Set(channels)].sort() : [];
                this.generalService.saveDataInSession('visited_channels', uniqueChannels);
                if (channels && uniqueChannels && channels.length === uniqueChannels.length && channelTitle && channelTitle.length > 0) {
                    this.trackAnalytics({
                        'channel': channelTitle,
                        'aheventtype': 'uservisits'
                    });
                }
            }
        }
        catch (ex) {
            console.log("Error: GA logging failed.")
        }
    }
    trackSearchAnalyticsInfo(searchKey: string): void {
        try {

            this.trackAnalytics({
                'aheventtype': 'searchkeywords',
                'searchkeyword': searchKey
            });
        }
        catch (ex) {
            console.log("Error: GA logging failed.")
        }
    }

    isToday(date: string) {
        const today = new Date()
        const someDate = new Date(date);
        return someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear()
    }


    async trackAnalytics(customInfo) {

        let analyticsInfo = this.generalService.getDataFromSession('analytics_general')

        if (!analyticsInfo) {
            const userProfile = await this.userService.getCurentUserProfile()
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const ct = require('countries-and-timezones');
            const zone = moment.tz.guess();
            const timezone = ct.getCountryForTimezone(zone);            
            let finalcountry = userProfile.Country ? userProfile.Country : timezone.name;
            finalcountry = (finalcountry.toLowerCase() == "us" || finalcountry.toLowerCase() == "united states" || finalcountry.toLowerCase() =="united states of america" || finalcountry.toLowerCase() == "usa") ? "United States" : finalcountry;
            analyticsInfo = {
                'event': "downloadTrackerInfo",
                'user': userProfile.Email.toLowerCase().split("@")[0],
                'country': finalcountry,
                'region': zone.split('/')[0],
                'timezone': userProfile.UserTimeZone
            };
            this.generalService.saveDataInSession('analytics_general', analyticsInfo);
            const d = new Date();
            this.generalService.saveDataInSession('timeout_session', d.toString());


        }

        const addInfo = {
            'eventtime': new Date(),
            'referrer': window.location.href
        }
        const result = {
            ...customInfo,
            ...addInfo,
            ...analyticsInfo,
        };
        window['dataLayer'].push(result);


    }
}